import { Logo } from 'src/Components/Logo';

import styles from './LogoHeader.module.scss';

const LogoHeader = () => {
  return (
    <div className={styles.container}>
      <Logo variant="icon" className={styles.menuLogo} />
      <Logo variant="wordmark" className={styles.textLogo} />
    </div>
  );
};

export default LogoHeader;
